//@ts-nocheck
import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch } from "../../app/hooks";
import { fetchJobPipelineDetailsData } from "../../features/pipeline/pipelineSlice";
import JobPipelineDetails from "./JobPipelineDetails";
import { toast } from "sonner";
import JobPipelineStagesDetails from "./JobPipelineStagesDetails";

const PipelineContainer: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [pipelineData, setPipelineData] = useState<any>(null);
  const [pipelineDataDetails, setPipelineDataDetails] = useState<any>(null);
  const { baseId, jobId } = useParams<{ baseId: string; jobId: string }>();
  const dispatch = useAppDispatch();

  const fetchPipelineData = useCallback(async () => {
    if (!baseId || !jobId) {
      toast.error("Invalid Base ID or Job ID");
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      const response = await dispatch(
        fetchJobPipelineDetailsData({
          baseId: Number(baseId),
          JobId: jobId,
        }),
      );

      if (
        response.meta.requestStatus === "fulfilled" &&
        response.payload?.data
      ) {
        setPipelineData(response.payload.data.stages);
        setPipelineDataDetails(response.payload.data);
      }
    } catch (error) {
      console.error("Error fetching pipeline details:", error);
      toast.error("Failed to fetch pipeline details");
    } finally {
      setLoading(false);
    }
  }, [baseId, jobId, dispatch]);

  // Add useEffect to fetch data when component mounts
  useEffect(() => {
    fetchPipelineData();
  }, [fetchPipelineData]);

  const handleSetPipelineData = useCallback(
    (newData: any) => {
      if (newData?.stages) {
        setPipelineData(newData.stages);
        setPipelineDataDetails(newData);
      } else {
        setPipelineData(newData);
        fetchPipelineData();
      }
    },
    [fetchPipelineData],
  );

  const hasPipelineData =
    pipelineData && Array.isArray(pipelineData) && pipelineData.length > 0;

  const hasPipelineDetails =
    pipelineDataDetails && Array.isArray(pipelineDataDetails.stages);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-[calc(100vh_-_5rem)]">
        <div className="simple-spinner-loader">
          <span></span>
        </div>
      </div>
    );
  }

  return (
    <>
      {hasPipelineDetails ? (
        <JobPipelineStagesDetails
          pipelineData={pipelineData}
          setPipelineData={handleSetPipelineData}
          pipelineDataDetails={pipelineDataDetails}
        />
      ) : (
        <JobPipelineDetails
          pipelineData={pipelineData}
          setPipelineData={handleSetPipelineData}
        />
      )}
    </>
  );
};

export default PipelineContainer;
